<template>
    <b-container>
        <b-row v-if="isIntuitApp" class="d4d-decoration">
        </b-row>
        <b-row v-if="isJAApp" class="ja-decoration">
        </b-row>
    
        <b-row class="d4d-login">
                
                <b-col cols="12" class="mt-1 title">Your consent has been confirmed</b-col>

                <b-col cols="12" class="mt-3">
                    <p class="text">Thank you for creating a Design for Delight account.</p>
                </b-col>
                <b-col cols="12" class="mt-2 button-content ">
                    <b-button block variant="primary" :to="{ name: 'Login' }">Continue to Log in</b-button>
                </b-col>
        </b-row>
        <legal-message/>
    </b-container>
</template>

<script>
    import LegalMessage from "../Components/LegalMessage"

    export default {
        name: 'ParentConsentConfirmed',
        components: { LegalMessage }
    }

</script>

<style scoped lang="stylus">
    @import "../Styles/security_styles.styl"

    .remember
        font-family arial, sans-serif
        font-size 14px

    .last-updated
        font-family arial, sans-serif
        font-size 12px
        font-weight bold
        font-style italic
        color black

</style>